module.exports = __webpack_public_path__ + "img/bella-heart.1ec96db7.svg";